module.exports = __webpack_public_path__ + "static/media/maps.a8d169b4.png";